import React, { FC } from 'react'

export const Mosaic: FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 7V3H7L6.997 7H3ZM1 7C1 8.103 1.897 9 3 9H7C8.103 9 9 8.103 9 7V3C9 1.897 8.103 1 7 1H3C1.897 1 1 1.897 1 3V7ZM13 7V3H17L16.997 7H13ZM11 7C11 8.103 11.897 9 13 9H17C18.103 9 19 8.103 19 7V3C19 1.897 18.103 1 17 1H13C11.897 1 11 1.897 11 3V7ZM3 13V17H6.997L7 13H3ZM3 19C1.897 19 1 18.103 1 17V13C1 11.897 1.897 11 3 11H7C8.103 11 9 11.897 9 13V17C9 18.103 8.103 19 7 19H3ZM13 17V13H17L16.997 17H13ZM11 17C11 18.103 11.897 19 13 19H17C18.103 19 19 18.103 19 17V13C19 11.897 18.103 11 17 11H13C11.897 11 11 11.897 11 13V17Z"
      fill="currentColor"
    />
  </svg>
)
